export const dashedNric = (nric: string) => {
  const dob = nric.substring(0, 6).padEnd(7, '-');
  const state = nric.substring(6, 8).padEnd(3, '-');
  const uid = nric.substring(8, 14);
  return dob.concat(state, uid);
};

export const getBase64 = (dataUri: string) => {
  if (typeof dataUri !== 'string') return undefined;

  const base64Index = dataUri.indexOf(';base64,');
  if (base64Index === -1) return undefined;

  return dataUri.substring(base64Index + 8);
};
